const PRODUCT_INFORMATION = 'Product Information';
const DESIGN_DETAILS = 'Design Details';
const BILL_OF_MATERIALS = 'Bill of Materials';
const SPECIFICATIONS = 'Specifications';
const CARE_USER_INSTRUCTIONS = 'Care/User Instructions';
const TESTING = 'Testing';
const SAMPLES = 'Samples';
const COSTINGS = 'Costings';
const PURCHASE_ORDERS = 'Purchase Orders';

const LOCATION_CANONICAL_MAP: Record<string, string> = {
  [PRODUCT_INFORMATION]: PRODUCT_INFORMATION,
  ProductInfoList: PRODUCT_INFORMATION,
  'Design Detail': DESIGN_DETAILS,
  [DESIGN_DETAILS]: DESIGN_DETAILS,
  DESIGN_DETAIL: DESIGN_DETAILS,
  BOM: BILL_OF_MATERIALS,
  [BILL_OF_MATERIALS]: BILL_OF_MATERIALS,
  SPEC: SPECIFICATIONS,
  [SPECIFICATIONS]: SPECIFICATIONS,
  'Care User Instruction': CARE_USER_INSTRUCTIONS,
  [CARE_USER_INSTRUCTIONS]: CARE_USER_INSTRUCTIONS,
  CARE_USER_INSTRUCTION: CARE_USER_INSTRUCTIONS,
  [TESTING]: TESTING,
  TESTING,
  [SAMPLES]: SAMPLES,
  samples: SAMPLES,
  Costing: COSTINGS,
  [COSTINGS]: COSTINGS,
  'Purchase Order': PURCHASE_ORDERS,
  [PURCHASE_ORDERS]: PURCHASE_ORDERS,
  PURCHASE_ORDER: PURCHASE_ORDERS,
};

const DEFAULT_ROUTE_PATH = 'product-identifier';

const LOCATION_ROUTE_MAP: Record<string, string> = {
  [SAMPLES]: 'samples',
  [COSTINGS]: 'product-costing',
  [BILL_OF_MATERIALS]: 'bom',
  [SPECIFICATIONS]: 'measurement',
  [TESTING]: 'testing/testing-requirements',
  [DESIGN_DETAILS]: 'design-details/list',
  [CARE_USER_INSTRUCTIONS]: 'care-user-instruction',
  [PRODUCT_INFORMATION]: DEFAULT_ROUTE_PATH,
  [PURCHASE_ORDERS]: 'product-purchase-order',
};

/**
 * @description Reduces the many spellings a todo `location` can be persisted with
 * (chat module keys, legacy singulars, display labels) to one canonical label.
 * @param location Raw `location` value stored on the todo.
 * @returns Canonical location label, or an empty string when the input is blank.
 */
export const resolveCanonicalLocation = (location?: string | null): string => {
  const trimmed = (location ?? '').trim();
  if (!trimmed) {
    return '';
  }
  return LOCATION_CANONICAL_MAP[trimmed] ?? trimmed;
};

/**
 * @description Human-readable label rendered in the Location column.
 * @param location Raw `location` value stored on the todo.
 * @returns Canonical label, or `-` when the todo has no location.
 */
export const resolveLocationDisplay = (location?: string | null): string => {
  return resolveCanonicalLocation(location) || '-';
};

/**
 * @description Development-order sub-route the todo's location points at.
 * @param location Raw `location` value stored on the todo.
 * @returns Sub-route path, falling back to the product identifier tab when the
 * location is unknown or belongs to a module without a development-order screen.
 */
export const resolveLocationRoutePath = (location?: string | null): string => {
  return LOCATION_ROUTE_MAP[resolveCanonicalLocation(location)] ?? DEFAULT_ROUTE_PATH;
};
